import React from "react";
import CheckPrivateClientInfo from "../../screens/auth/CheckPrivateClientInfo";
import { MockedProvider } from "@apollo/client/testing/react";
import type { Meta, StoryObj } from "@storybook/react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { StoryStackNavigatorContainer } from "../display-helpers";

const Stack = createNativeStackNavigator<{
    CheckPrivateClientInfo?: { isNewProfile: boolean };
}>();

const StoryComponent = () => {
    return (
        <MockedProvider mocks={[]}>
            <StoryStackNavigatorContainer>
                <Stack.Navigator initialRouteName="CheckPrivateClientInfo">
                    <Stack.Screen
                        name="CheckPrivateClientInfo"
                        component={CheckPrivateClientInfo}
                    />
                </Stack.Navigator>
            </StoryStackNavigatorContainer>
        </MockedProvider>
    );
};

const meta = {
    title: "Screens/Check private client info",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
